export class CloseCredentialsDialogEvent {}
